module.exports = __webpack_public_path__ + "fonts/roboto-condensed-v18-latin-700.114cd18.woff2";